import type { BadgeProps } from '@/components/ui/Badge';
import type { CsTicketPriority, CsTicketStatus, CsTier } from '@/api/cs/tickets.api';

/**
 * Shared CS label/variant vocabulary (Phase 16 / ADR-026). Lives apart
 * from the badge components so pages can reuse the label maps (selects,
 * chips) without tripping react-refresh's components-only rule.
 */

export const STATUS_META: Record<CsTicketStatus, { label: string; variant: BadgeProps['variant'] }> = {
  new_ticket: { label: 'New', variant: 'info' },
  open: { label: 'Open', variant: 'success' },
  pending: { label: 'Pending', variant: 'warning' },
  resolved: { label: 'Resolved', variant: 'neutral' },
  closed: { label: 'Closed', variant: 'neutral' },
};

export const PRIORITY_META: Record<CsTicketPriority, { label: string; variant: BadgeProps['variant'] }> = {
  low: { label: 'Low', variant: 'neutral' },
  medium: { label: 'Medium', variant: 'info' },
  high: { label: 'High', variant: 'warning' },
  urgent: { label: 'Urgent', variant: 'danger' },
};

export const TIER_META: Record<CsTier, { label: string; variant: BadgeProps['variant'] }> = {
  tier1_auto: { label: 'Tier 1 · Auto', variant: 'success' },
  tier2_semi: { label: 'Tier 2 · Semi', variant: 'info' },
  tier3_human: { label: 'Tier 3 · Human', variant: 'neutral' },
};
